import React, { useState } from "react";
import axios from "axios";
import url from "../../url.json";
import { withTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import headers from "../../config/headers";
import { emailReducer } from "../../Redux/Reducers/Email/email";
import ResetShell, { parseError, firstMsg } from "./ResetShell";

function Forgot({ t }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [load, setload] = useState(false);
  const [error, setError] = useState();
  const [serverError, setServerError] = useState();

  const handleSubmit = (e) => {
    e.preventDefault();
    setload(true);
    setServerError();
    axios
      .post(url.url + "/mail", { email }, { headers: headers() })
      .then((res) => {
        toast.success(res.data.data.success);
        dispatch(emailReducer(email));
        setError();
        navigate("/createpassword");
      })
      .catch((err) => {
        const { errors, lines, status } = parseError(err);
        if (status === 401) {
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          window.location = "/";
          return;
        }
        // email maydoni xatosi maydon ostida, qolganlari umumiy xabarda
        setError(errors);
        if (!errors?.email) setServerError(lines);
        toast.error(lines[0] || t("Code sending failed"));
      })
      .finally(() => setload(false));
  };

  return (
    <ResetShell step={0}>
      <h2 className="ln-login__title">{t("Forgot password")}</h2>
      <p className="ln-reset__hint">{t("ln_reset_email_hint")}</p>
      <form className="ln-login__form" onSubmit={handleSubmit} noValidate>
        <div className={"ln-field" + (error?.email ? " has-error" : "")}>
          <label htmlFor="resetEmail">{t("Email")}</label>
          <input
            id="resetEmail"
            name="email"
            type="email"
            autoComplete="email"
            placeholder="example@mail.uz"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              if (error?.email) setError();
            }}
            autoFocus
          />
          {error?.email ? <i className="ln-login__error">{firstMsg(error.email)}</i> : ""}
        </div>

        {serverError ? (
          <div className="ln-reset__alert" role="alert">
            <strong>{t("Code sending failed")}</strong>
            {serverError.map((m, i) => (
              <span key={i}>{m}</span>
            ))}
          </div>
        ) : null}

        <button type="submit" className="ln-btn ln-btn_dark ln-login__submit" disabled={load || !email.trim()}>
          {load ? t("sending") : t("Send code")}
        </button>
      </form>
    </ResetShell>
  );
}
export default withTranslation()(Forgot);
